exports.components = {
  "component---src-pages-404-tsx": () => import("./../../../src/pages/404.tsx" /* webpackChunkName: "component---src-pages-404-tsx" */),
  "component---src-pages-index-tsx": () => import("./../../../src/pages/index.tsx" /* webpackChunkName: "component---src-pages-index-tsx" */),
  "component---src-templates-design-project-tsx": () => import("./../../../src/templates/design-project.tsx" /* webpackChunkName: "component---src-templates-design-project-tsx" */),
  "component---src-templates-dev-project-tsx": () => import("./../../../src/templates/dev-project.tsx" /* webpackChunkName: "component---src-templates-dev-project-tsx" */)
}

